import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import HomePage from "./pages/HomePage";
import RoomCategoriesPage from "./pages/RoomCategoriesPage";
import GalleryPage from "./pages/GalleryPage";
import NearbyPlacesPage from "./pages/NearbyPlacesPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rooms" element={<RoomCategoriesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/nearby" element={<NearbyPlacesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
